import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from '../../helpers/api_helper';
import Log from '../../Services/Log';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';
  

export const businessInfo = createAsyncThunk('vendor/info', async (info, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.BUSINESS_INFO.GET);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

